import { NOT_SCORED_TEXT, type NotScoredReason } from './scoring.ts';

/**
 * Admin mocks for a spoken answer, sent as request headers. The server honours them only for an admin on their test
 * account (/api/answers in src/server/app.ts, ADR-0014); everywhere else they are ignored.
 */
export const MOCK_HEADERS = { scorer: 'x-fuse-scorer', review: 'x-fuse-review' } as const;

/** `fake`: the recorded scores instead of the fleet. A reason: not scored, for that reason. */
export const SCORER_MOCKS = ['fake', ...(Object.keys(NOT_SCORED_TEXT) as NotScoredReason[])] as const;
export type ScorerMock = (typeof SCORER_MOCKS)[number];
export type AnswerMocks = { scorer?: ScorerMock; review?: 'fail' };

export function readAnswerMocks(header: (name: string) => string | undefined): AnswerMocks {
  const scorer = header(MOCK_HEADERS.scorer);
  const review = header(MOCK_HEADERS.review);
  return {
    ...(SCORER_MOCKS.includes(scorer as ScorerMock) ? { scorer: scorer as ScorerMock } : {}),
    ...(review === 'fail' ? { review: 'fail' as const } : {}),
  };
}
